module.exports = __webpack_public_path__ + "img/banner_pay.4f6fe391.png";